import {createSlice} from "@reduxjs/toolkit";

const initiallistingRepriceRulesState = {
  listLoading: false,
  actionsLoading: false,
  total_count: 0,
  entities: null,
  listingRepriceRuleForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const listingRepriceRulesSlice = createSlice({
  name: "listingRepriceRules",
  initialState: initiallistingRepriceRulesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getlistingRepriceRuleById
    listingRepriceRuleFetched: (state, action) => {
      state.actionsLoading = false;
      state.listingRepriceRuleForEdit = action.payload.listingRepriceRuleForEdit;
      state.error = null;
    },
    // findlistingRepriceRules
    listingRepriceRulesFetched: (state, action) => {
      const { total_count, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.total_count = total_count;
    },
    // createlistingRepriceRule
    listingRepriceRuleCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      // state.entities.push(action.payload.listingRepriceRule);
    },
    // updatelistingRepriceRule
    listingRepriceRuleUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
    },
    // deletelistingRepriceRule
    listingRepriceRuleDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      // state.entities = state.entities.filter(el => el.id !== action.payload.id);
    },
    // deletelistingRepriceRules
    listingRepriceRulesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.id)
      );
    },
    // listingRepriceRulesUpdateState
    listingRepriceRulesStatusUpdated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { ids, status } = action.payload;
      state.entities = state.entities.map(entity => {
        if (ids.findIndex(id => id === entity.id) > -1) {
          entity.status = status;
        }
        return entity;
      });
    }
  }
});
